import AppConfigProvider from "@/app/providers/app-config-provider";
import SkipToContent from "@/components/ui/skip-to-content";
import { publicEnv } from "@/config/env";
import CookieConsent from "@/features/shared/components/cookie-consent";
import Footer from "@/features/shared/components/footer/footer";
import FooterWrapper from "@/features/shared/components/footer/footerwrapper";
import Header from "@/features/shared/components/header/header";
import Navbar from "@/features/shared/components/navbar/navbar";
import {
  formatAppTitle,
  getDetailEntityName,
  PORTAL_DESCRIPTION_BY_LNG
} from "@/lib/app-document-title";
import { getCookie } from "@/lib/cookies";
import { getTypedTheme, THEME_COOKIE_NAME } from "@/lib/theme";
import { getShortLngFromCulture } from "@/utils/get-short-lng";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_app")({
  head: () => {
    const lng = getShortLngFromCulture(getCookie("shop-culture"));
    const description = PORTAL_DESCRIPTION_BY_LNG[lng] ?? PORTAL_DESCRIPTION_BY_LNG.sv;
    return {
      meta: [
        { title: formatAppTitle(getDetailEntityName()) },
        { name: "description", content: description }
      ],
      links: [
        {
          rel: "manifest",
          href: `${publicEnv.SELF_URL ?? ""}/ee-static/membersapp/manifest.json`
        }
      ]
    };
  },
  component: AppLayout
});

function AppLayout() {
  const lng = getShortLngFromCulture(getCookie("shop-culture"));
  const initialTheme = getTypedTheme(getCookie(THEME_COOKIE_NAME)?.toString());

  useEffect(() => {
    document.documentElement.lang = lng;
  }, [lng]);

  return (
    <AppConfigProvider initialTheme={initialTheme}>
      <div className="relative flex min-h-dvh flex-col font-[Inter,sans-serif]">
        <SkipToContent />
        <div className="flex flex-1 flex-col pb-4 md:pb-16">
          <Header />
          <main
            id="main-content"
            className="flex w-full flex-1 flex-col pb-[var(--navbar-height)] md:pb-0"
          >
            <Outlet />
          </main>
        </div>
        <FooterWrapper>
          <Footer lng={lng} />
        </FooterWrapper>
      </div>
      <Navbar />
      <CookieConsent variant="default" />
    </AppConfigProvider>
  );
}
